import * as React from 'react';

const SvgCheck = (props) => (
  <svg
    width={22}
    height={22}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 .25c-2.574 0-4.57.51-5.905 1.845C.76 3.429.25 5.426.25 8v6c0 2.574.51 4.57 1.845 5.905C3.429 21.24 5.426 21.75 8 21.75h6c2.574 0 4.57-.51 5.905-1.845C21.24 18.571 21.75 16.574 21.75 14V8c0-2.574-.51-4.57-1.845-5.905C18.571.76 16.574.25 14 .25H8ZM1.75 8c0-2.426.49-3.93 1.405-4.845C4.071 2.24 5.574 1.75 8 1.75h6c2.426 0 3.93.49 4.845 1.405.915.916 1.405 2.419 1.405 4.845v6c0 2.426-.49 3.93-1.405 4.845-.916.915-2.419 1.405-4.845 1.405H8c-2.426 0-3.93-.49-4.845-1.405C2.24 17.929 1.75 16.426 1.75 14V8Zm14.82-.512a.75.75 0 0 0-1.14-.976L10.04 12.8a.25.25 0 0 1-.34.037L6.45 10.4a.75.75 0 1 0-.9 1.2l3.25 2.438a1.75 1.75 0 0 0 2.38-.261l5.39-6.289Z'
      fill='#333'
    />
  </svg>
);

export default SvgCheck;
